import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from '@/common/i18n/locales/en.json';
import fr from '@/common/i18n/locales/fr.json';
import it from '@/common/i18n/locales/it.json';

Vue.use(VueI18n);

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }
  },
  fr: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }
  },
  it: {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }
  }
};

const numberFormats = {
  fr: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  it: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
};

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_DEFAULT_LOCALE || 'fr',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  messages: { en, fr, it },
  dateTimeFormats,
  numberFormats
});

export default i18n;
